import { ChangeEvent, FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Input } from 'src/components/common/Input';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { useResetSignUpError } from 'src/hooks/useResetSignupErrors';
import { setError } from 'src/store/user/actions';
import { RootState } from 'src/types/store-types';
import * as Yup from 'yup';

type IProps = {
  name: string;
  value: string;
  regexp: string;
  onChange: (e: any) => void;
  placeholder?: string;
  required?: boolean;
};
const Address_Input: FC<IProps> = (props) => {
  // Hooks
  const { t }: Translation = useTranslation();

  // Redux
  const _setErrorReq = useConnectedAction(setError);
  const resetSignUpError = useResetSignUpError();

  // Selectors
  const { errors: signUpErrors, dniResult, additionalInfo } = useSelector((state: RootState) => state.user);
  const { apartment, floor, street, streetNumber } = dniResult || {};
  const { address } = additionalInfo || {};
  // YUP Validation
  const validationSchema = Yup.object().shape({
    address: Yup.string().required(t('requiredField')).matches(new RegExp(props.regexp), t('fieldLength')),
  });

  const handleValidate = async (value: string): Promise<void> => {
    try {
      await validationSchema.validate({ address: value }, { abortEarly: false });
      resetSignUpError('address');
    } catch (error: any) {
      if (error.name === 'ValidationError') {
        _setErrorReq({ ...signUpErrors, address: error.errors[0] });
      }
    }
  };

  // Actions
  const handleOnChange = (e: ChangeEvent<HTMLInputElement>): void => {
    if (signUpErrors.address) {
      resetSignUpError('address');
    }
    props.onChange(e);
  };

  const handleBlur = (): void => {
    handleValidate(props.value?.trim()).catch((e) => console.log(e));
  };

  useEffect(() => {
    if (Object.keys(dniResult).length && (apartment || floor || street || streetNumber)) {
      const value = `${street}, ${streetNumber}, Depto ${apartment}, Piso ${floor}`;
      props.onChange({
        target: { name: props.name, value },
      });
      handleValidate(value).catch((e) => console.log(e));
    } else if (Object.keys(additionalInfo).length && address) {
      props.onChange({
        target: { name: props.name, value: address },
      });
      handleValidate(address).catch((e) => console.log(e));
    }
  }, [dniResult, additionalInfo]);

  return <Input error={signUpErrors.address} {...props} onChange={handleOnChange} onBlur={handleBlur} />;
};
export default Address_Input;
